import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import './firebaseConfig'
import {auth} from './firebaseConfig'
//import '@babel/polyfill'
import 'babel-polyfill'

import './toasts/msgs'
import "./plugins/vuetify-money.js";
import "./plugins/vue-chart.js";
import "./plugins/vue-moment.js";
import "./plugins/vue-mask.js";
import "./plugins/v-viewer.js";

Vue.config.productionTip = false;

//Vue.use(VueFire)

/*new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
*/
let app;

auth.onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount('#app')
  }
})

